export default __webpack_public_path__ + "c7be05ff4df2080fb6be5d64ffe48af4.jpg";